module.exports = __webpack_public_path__ + "static/media/plus.ae952905.jpg";